/*@ngInject*/
const DataSetBrowserActionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.loadActions = function () {
        var url = '/rest/Actions',
            config = {
                params: {
                    uri: 'com.firstbest.data.DataSet:null'
                }
            };

        return this.get(url, config);
    };
};

angular.module('ums.configuration')
    .service('dataSetBrowserActionRepository', DataSetBrowserActionRepository);
